export const formContent = {
    heading: 'Forgot Password?',
    description: 'To recover your password, you need to enter your registered email address. We will send the recover password to your email',
    email: {
        id: 'email',
        label: 'Email',
        validation: {
            required: "Email is required"
        }
    },
    recoverPasswordButton: {
        id: 'recoverPasswordButton',
        label: 'Recover Password',
        type: 'submit'
    },
}
